import axios from 'axios'
import { handleError } from '@/helpers/HandleError';
import * as general_state from '../store';
import router from '../../router/router'

const state = {
    evalvation_programs_all: {},
    evalvation_programs_user: {},
    evalvation_programs_multiple_fill: [],
    evalvation_departments: {},
    user_access_lists: {
        year: '',
        programs_list: {},
        departments_list: {}
    }
};

const getters = {
    evalvation_programs_all: state => state.evalvation_programs_all,
    evalvation_programs_user: state => state.evalvation_programs_user,
    evalvation_departments: state => state.evalvation_departments,
    evalvation_programs_multiple_fill: state => state.evalvation_programs_multiple_fill,
    user_access_lists: state => state.user_access_lists,
};

const mutations = {
    getProgramsListAll: (state, payload) => {
        state.evalvation_programs_all = payload;
    },
    getProgramsListForUser: (state, payload) => {
        state.evalvation_programs_user = payload;
    },
    getDepartmentsList: (state, payload) => {
        state.evalvation_departments = payload;
    },
    getProgramsListUserAccess: (state, payload) => {
        state.user_access_lists.programs_list = payload;
    },
    getYearUserAccess: (state, payload) => {
        state.user_access_lists.year = payload;
    },
    getDepartmentsListUserAccess: (state, payload) => {
        state.user_access_lists.departments_list = payload;
    },
    setProgramsMultipleFill: (state, payload) => {
        state.evalvation_programs_multiple_fill = payload;
    },
    resetProgramsMultipleFill: (state) => {
        state.evalvation_programs_multiple_fill = [];
    },
    allProgramsSubmitted: (state) => {
        for (let program_id in state.evalvation_programs_user) {
            if (state.evalvation_programs_user[program_id].faculty_id == general_state.state.faculty.id)
                state.evalvation_programs_user[program_id].submitted = 1;
        }
    },
    allProgramsSubmittedRepeal: (state) => {
        for (let program_id in state.evalvation_programs_user) {
            if (state.evalvation_programs_user[program_id].faculty_id == general_state.state.faculty.id)
                state.evalvation_programs_user[program_id].submitted = 0;
        }
    },
};

const actions = {
	// Prepare list of all programs
	getProgramsListAll: ({commit}, payload) => {
		commit('showModalWorking');
		let year = (payload && payload.year) ? payload.year : general_state.state.year;
		axios.get('?module=evalvation_program&action=get_list&year='+year)
			.then(
				res => {
					if(res.data.error){				
						commit('hideModalWorking');
						commit('showModal', {component: 'ModalError', data: res.data.error})
					}
					else{
						if(payload && payload.year)
							commit('getProgramsListUserAccess', res.data);
						else
							commit('getProgramsListAll', res.data);
						commit('hideModalWorking');
					}
				}
			)
			.catch(error => handleError(commit, error));		
	},

	// Prepare list of program for this user 
	getProgramsListForUser: ({commit}, payload) => {
		commit('showModalWorking');
		axios.get('?module=evalvation_program&action=get_list_user&year='+general_state.state.year)
			.then(
				res => {
					if(res.data.error){				
						commit('hideModalWorking');
						commit('showModal', {component: 'ModalError', data: res.data.error})
					}
					else{
						commit('getProgramsListForUser', res.data);
						commit('hideModalWorking');
					}
				}
			)
			.catch(error => handleError(commit, error));		
	},

	// Prepare list of program for this faculty (admin) 
	getProgramsListForFaculty: ({commit}, payload) => {
		commit('showModalWorking');
		let year = (payload && payload.year) ? payload.year : general_state.state.year;
		axios.get('?module=evalvation_program&action=get_list_faculty&year='+year+'&faculty='+general_state.state.faculty.id)
			.then(
				res => {
					if(res.data.error){				
						commit('hideModalWorking');
						commit('showModal', {component: 'ModalError', data: res.data.error})
					}
					else{
						if(payload && payload.year)
							commit('getProgramsListUserAccess', res.data);
						else
							commit('getProgramsListForUser', res.data);
						commit('hideModalWorking');
					}
				}
			)
			.catch(error => handleError(commit, error));		
	},

	// Prepare list of departments for faculty
	getDepartmentsListForFaculty: ({commit}, payload) => {
		commit('showModalWorking');
		let year = (payload && payload.year) ? payload.year : general_state.state.year;
		axios.get('?module=evalvation_oddelek&action=get_list_faculty&year='+year+'&faculty='+general_state.state.faculty.id)
			.then(
				res => {
					if(res.data.error){				
						commit('hideModalWorking');
						commit('showModal', {component: 'ModalError', data: res.data.error})
					}
					else{
						if(payload && payload.year)
							commit('getDepartmentsListUserAccess', res.data);
						else
							commit('getDepartmentsList', res.data);
						commit('hideModalWorking');
					}
				}
			)
			.catch(error => handleError(commit, error));		
	},

	// Prepare list of departments
	getDepartmentsList: ({commit}, payload) => {
		commit('showModalWorking');
		let year = (payload && payload.year) ? payload.year : general_state.state.year;
		axios.get('?module=evalvation_oddelek&action=get_list&year='+year)
			.then(
				res => {
					if(res.data.error){				
						commit('hideModalWorking');
						commit('showModal', {component: 'ModalError', data: res.data.error})
					}
					else{
						if(payload && payload.year)
							commit('getDepartmentsListUserAccess', res.data);
						else
							commit('getDepartmentsList', res.data);
						commit('hideModalWorking');
					}
				}
			)
			.catch(error => handleError(commit, error));		
	},

	// Prepare list of departments for user
	getDepartmentsListForUser: ({commit}) => {
		commit('showModalWorking');
		axios.get('?module=evalvation_oddelek&action=get_list_user&year='+general_state.state.year)
			.then(
				res => {
					if(res.data.error){				
						commit('hideModalWorking');
						commit('showModal', {component: 'ModalError', data: res.data.error})
					}
					else{
						commit('getDepartmentsList', res.data);
						commit('hideModalWorking');
					}
				}
			)
			.catch(error => handleError(commit, error));		
	},

	// Prepare lists and data for user access
	getListsForUserAccess: ({ commit, dispatch }, payload) => {
        const year = payload.year ?? general_state.state.year;
        const user = general_state.state.user;
        const faculty = general_state.state.faculty;

        if (user.type == 2) {
            dispatch('getDepartmentsList', { year });
            if (year === general_state.state.year && Object.keys(state.evalvation_programs_all).length > 0) {
                commit('getProgramsListUserAccess', state.evalvation_programs_all);
            } else {
                dispatch('getProgramsListAll', { year });
            }
        } else if (user.type == 1) {
            if (year === general_state.state.year && Object.keys(state.evalvation_departments).length > 0) {
                commit('getDepartmentsListUserAccess', state.evalvation_departments);
            } else {
                dispatch('getDepartmentsListForFaculty', { year });
            }

            if (year === general_state.state.year && Object.keys(state.evalvation_programs_user).length > 0) {
                commit('getProgramsListUserAccess', state.evalvation_programs_user);
            } else {
                dispatch('getProgramsListForFaculty', { year });
            }
        }

        commit('getYearUserAccess', year);
    },

	// Set list of programs that user choosed to fill out at once
	setProgramsMultipleFill: ({ commit, state }, payload) => {
        let arr = [...state.evalvation_programs_multiple_fill];

        if (payload.add)
            arr.push(payload.id);
        else
            arr = arr.filter(item => item !== payload.id);

        commit('setProgramsMultipleFill', arr);
    },

	// Reset list of programs that user choosed to fill out at once
	resetProgramsMultipleFill: ({ commit }) => {
        commit('resetProgramsMultipleFill');
    },

	// Check if data of multiple programs is the same
	checkMultiprogramData: ({commit, state}, payload) => {
		commit('showModalWorking');
		axios.post('?module=evalvation_data&action=check_multiprogram_data&year='+general_state.state.year+'&faculty='+general_state.state.faculty.id, {program_ids: state.evalvation_programs_multiple_fill})
			.then(
				res => {
					if(res.data.error){		
						commit('hideModalWorking');
						commit('showModal', {component: 'ModalError', data: res.data.error})
					}
					else{
						commit('hideModalWorking');

						//data is the same
						if(res.data.check)
							router.replace('/samoevalvacija/podrobnosti/1/'+state.evalvation_programs_multiple_fill.join(','));
						//data is different
						else
							commit('showModal', {component: 'evalvation/MultipleFillOverrideWarning', data: {program_ids: state.evalvation_programs_multiple_fill}});
					}
				}
			)
			.catch(error => handleError(commit, error));
	},

	// Copy data of multiple programs
	copyMultiprogramData: ({commit}, payload) => {
		commit('showModalWorking');
		axios.post('?module=evalvation_data&action=copy_multiprogram_data&year='+general_state.state.year+'&faculty='+general_state.state.faculty.id, {program_ids: state.evalvation_programs_multiple_fill})
			.then(
				res => {
					if(res.data.error){		
						commit('hideModalWorking');
						commit('showModal', {component: 'ModalError', data: res.data.error})
					}
					else{
						if(res.data.success)
							router.replace('/samoevalvacija/podrobnosti/1/'+state.evalvation_programs_multiple_fill.join(','));
						else
							commit('showModal', {component: 'ModalError', data: "Napaka pri združevanju podatkov"});

						commit('hideModalWorking');
					}
				}
			)
			.catch(error => handleError(commit, error));		
	},

	// Set program to finished
	setProgramFinished: ({commit, dispatch}, payload) => {
		commit('showModalWorking');
		axios.post('?module=evalvation_program&action=set_program_finished&program_id='+payload.program_id, payload)
			.then(
				res => {
					if(res.data.error){				
						commit('hideModalWorking');
						commit('showModal', {component: 'ModalError', data: res.data.error})
					}
					else{
						commit('hideModalWorking');

						if(general_state.state.user.type > 1)
							dispatch('getProgramsListAll'); 
						if(general_state.state.user.type > 0)
							dispatch('getProgramsListForFaculty');
						else
							dispatch('getProgramsListForUser');

						commit('showModal', {component: 'evalvation/FillFinished', data:{type: 1, allFinished: res.data.allFinished}});
					}
				}
			)
			.catch(error => handleError(commit, error));		
	},

	// Set department to finished
	setDepartmentFinished: ({commit, dispatch}, payload) => {
		axios.get('?module=evalvation_program&action=set_department_finished&department_id='+payload.department_id)
			.then(
				res => {
					if(res.data.error){				
						commit('showModal', {component: 'ModalError', data: res.data.error})
					}
					else{
						commit('showModal', {component: 'evalvation/FillFinished', data:{type: 2}});
						commit('setDepartmentFinishedStatus', '1', { root: true });

					}
				}
			)
			.catch(error => handleError(commit, error));			
	},

	//Repeal program to finished
	repealProgramFinished: ({commit, dispatch}, payload) => {
		commit('showModalWorking');
		axios.get('?module=evalvation_program&action=repeal_program_finished&program_id='+payload.program_id)
			.then(
				res => {
					if(res.data.error){				
						commit('hideModalWorking');
						commit('showModal', {component: 'ModalError', data: res.data.error})
					}
					else{
						commit('hideModalWorking');

						commit('setProgramFinishedStatus', '0', { root: true });
					}
				}
			)
			.catch(error => handleError(commit, error));		
	},

	// Send a submittion of all programs of faculty
	sendProgramsSubmittion: ({commit}) => {
		commit('showModalWorking');
		axios.post('?module=evalvation_data&action=submit_faculty_data&faculty='+general_state.state.faculty.id+'&year='+general_state.state.year)
		.then(
			res => {
				if(!res.data.success){				
					var error = res.data.error ? res.data.error : "Napaka";
					commit('hideModalWorking');
					commit('showModal', {component: 'ModalError', data: error})
				}
				else{
					commit('allProgramsSubmitted');
					commit('hideModalWorking');
				}
			}
		)
		.catch(error => handleError(commit, error));	
	},

	// Send a repeal of submittion of all programs of faculty
	sendProgramsSubmittionRepeal: ({commit}) => {
		commit('showModalWorking');
		axios.post('?module=evalvation_data&action=repeal_submit_faculty_data&faculty='+general_state.state.faculty.id+'&year='+general_state.state.year)
		.then(
			res => {
				if(!res.data.success){				
					var error = res.data.error ? res.data.error : "Napaka";
					commit('hideModalWorking');
					commit('showModal', {component: 'ModalError', data: error})
				}
				else{
					commit('allProgramsSubmittedRepeal');
					commit('hideModalWorking');
				}
			}
		)
		.catch(error => handleError(commit, error));	
	},

	//Export package all programs data
	exportAllProgramsPackage: ({commit, dispatch}, payload) => {
		commit('showModalWorking');

		axios.get('?module=export&action=get_evalvation_export_all_programs&format='+payload.format+'&faculty='+general_state.state.faculty.id+'&year='+general_state.state.year)
			.then(
				res => {
					if(!res.data.success){		
						commit('hideModalWorking');		
						var error = res.data.error ? res.data.error : payload.data;
						commit('showModal', {component: 'ModalError', data: error})
					}
					else{
						commit('hideModalWorking');
						dispatch('downloadFile', {url:res.data.export_link, filename:res.data.export_filename});
					}
				}
			)
			.catch(error => handleError(commit, error));		
	},

	//Set programs hidden
	toggleHidePrograms: ({commit, dispatch}, payload) => {
		let hide = (payload == 1) ? 0 : 1;
		axios.get('?module=evalvation_program&action=toggle_hide_programs&hide='+hide+'&year='+general_state.state.year)
			.then(
				res => {
					if(!res.data.success){		
						var error = res.data.error ? res.data.error : payload.data;
						commit('showModal', {component: 'ModalError', data: error})
					}
					else{
						dispatch('getProgramsListAll'); 
					}
				}
			)
			.catch(error => handleError(commit, error));			 
	},
		
};


export default{
	state,
	getters,
	actions,
	mutations	
}